import {MiniEvent} from "@cdx/common";

export const apiErrorEvent = new MiniEvent();
